export default __webpack_public_path__ + "static/media/Data-Science-PT.a2b00ca3.jpg";